import { createReducer } from 'typesafe-actions';
import { createRoutineReducers, getInitialState } from '../common/utils/routine-reducer';
import { ssoLoginRoutine } from './actions';

export type SSOState = {
  loading: boolean;
  loaded: boolean;
  error: string;
  data: string;
};

export const initialState: SSOState = getInitialState('', 'loading', 'loaded');

export default createReducer<SSOState>(initialState, {
  ...createRoutineReducers(ssoLoginRoutine)
});
